rwgps = window.rwgps || {};
rwgps.TrackPoint = function(opts) {
  this.init(opts);
}

// SURFACE
rwgps.TrackPoint.inferSurface = function (s, rc, lat, lng) {
  if (s !== 95) { // 95 is S_OTHER
    return s
  }

  const map = rwgps.surfaces.stInfer.find(map => {
    const gllb = new google.maps.LatLngBounds({lat: map[0], lng: map[1]}, {lat: map[2], lng: map[3]})
    return gllb.contains({lat: lat, lng: lng})
  })
  if (map) {
    return rc !== undefined
      ? map[4][rc]
      : s
  } else {
    // eslint-disable-next-line
    console.warn(`unable to resolve surface type inferrence rule for {lat: ${lat}, lng: ${lng}}`)
  }
}

// takes track_points array
rwgps.TrackPoint.fromJSON = function(points, options) {
  if(!options)
    options = {};
  var clickIndexes = [];
  var tps = [];
  var prev = points[0];
  for(var i = 0; i < points.length; i++) {
    if(points[i] === null) continue;

    //bad eles come back as -9999, just using < -1000 just in case
    if(points[i].e < -1000) {
      if(points[i-1] && points[i-1].e != null && points[i-1].e >= -1000) {
        points[i].e = points[i-1].e;
      } else if(points[i+1] && points[i+1].e != null && points[i+1].e >= -1000) {
        points[i].e = points[i+1].e;
      } else {
        points[i].e = null;
      }
    }

    var p = points[i];
    var opts = {point:null, ele:p.e};
    if(p.y != null && p.x != null)
      opts.point = {lat: p['y'], lng: p['x']}
    // if in the route planner, don't assign distances, let them get calculated dynamically by metrics calculator
    // if we assign distances now they will be used to calculate deltas for the entire planning session, which will make
    // preexisting distance errors stick around forever. ignoring the cached d values will have them set based on
    // calculated distance between points throughout the planning session, which is less error prone.
    if(!options.planning && (p['d'] != null && p['d'] !== '') && (!prev['d'] || prev['d'] <= p['d'])) {
      opts.distance = p['d'];
    }

    var tp = new rwgps.TrackPoint(opts);
    tp.hr = p['h'];
    tp.cad = p['c'];
    tp.watts = p['p'];
    tp.time = p['t'];
    tp.temp = p['T'];
    tp.modified = p['m'];
    // SURFACE
    if (rwgps.surfaces && rwgps.surfaces.stInfer) {
      tp.roadClass = p['R'];
      tp.ghSurface = p['S'];
      tp.surface = rwgps.TrackPoint.inferSurface(p['S'], p['R'], p['y'], p['x'])
    }
    if (p['RE'] !== undefined) {
      tp.roadEnv = p['RE'];
      if (p['flat'] !== undefined) {
        tp.flattened = p['flat'];
      }
    }
    if (p['k']) {
      tp.excludeFromMetrics = true
      tp.exclude = true
    }
    if(!isNaN(p['s']) && p['s'] !== undefined)
      tp.speed = p['s'] * 3.6; //from FIT we get m/sec, not km/hour
    tps.push(tp);
    if(p["options"] || p["color"]) {
      clickIndexes.push(tps.length-1);
    } else if(prev && !prev["k"] && p["k"]) {
      clickIndexes.push(tps.length-1);
    } else if(prev && prev["k"] && !p["k"] &&
            !(prev.options || p.color)) { // prevent duplicate clickIndexes
      clickIndexes.push(tps.length-2);
    }

    prev = p;
  }
  if(clickIndexes.length > 0 && clickIndexes[clickIndexes.length-1] != points.length-1)
    clickIndexes.push(points.length-1);
  return {clickIndexes: clickIndexes, trackPoints: tps};
}

rwgps.TrackPoint.prototype = {
  point: null, // {lat, lng}
  distance: null,
  ele: null,
  hr: null,
  cad: null,
  watts: null,
  time: null,
  grade: null,
  speed: null,
  temp: null,
  excludeFromMetrics: null,
  segment: null,
  isControlPoint: false,
  prevSegment: null,
  nextSegment: null,
  surface: null, // int
  roadClass: null, // int
  ghSurface: null, // int
  roadEnv: null, // int
  modified: null, // bool
  flattened: null, // bool

  init: function(opts) {
    if(opts) {
      this.point = opts.point;
      this.time = opts.time;
      this.distance = opts.distance;
      if(opts.distance !== undefined) this.providedDistance = opts.distance;
      this.ele = opts.ele;
      this.segment = opts.segment;
      this.surface = opts.surface;
      this.roadClass = opts.roadClass;
      this.ghSurface = opts.ghSurface;
      this.roadEnv = opts.roadEnv;
      this.excludeFromMetrics = opts.excludeFromMetrics;
    }
  },
  googleLatLng: function() {
    if (!window.google || !window.google.maps) console.error("Google Maps not loaded, attempt to instantiate google.maps.LatLng") // eslint-disable-line
    if (this._googleLatLng === undefined) {
      this._googleLatLng = this.point ? new google.maps.LatLng(this.point.lat, this.point.lng) : null
    }
    return this._googleLatLng
  },
  pointEquals: function(pt) {
    return this.point.lat == pt.lat && this.point.lng == pt.lng;
  },
  // if two segment are connected, there can only be one control point connecting them so
  // one of the cps will be demoted with this fn
  ensureNotControlPoint: function() {
    this.isControlPoint = false;
    this.prevSegment = null;
    this.nextSegment = null;
  },
  setNextSegment: function(seg) {
    this.segment = null;
    this.isControlPoint = true;
    this.nextSegment = seg;
    if(seg) {
      seg.prevControlPoint = this;
      seg.prevSegment = this.prevSegment;
    }
    if(this.prevSegment) {
      this.prevSegment.nextSegment = seg;
    }
  },
  setPrevSegment: function(seg) {
    this.segment = null;
    this.isControlPoint = true;
    this.prevSegment = seg;
    if(seg) {
      seg.nextControlPoint = this;
      seg.nextSegment = this.nextSegment;
    }
    if(this.nextSegment) {
      this.nextSegment.prevSegment = seg;
    }
  },
  toMiniObj: function() {
    var pt = {};
    if(this.point) {
      pt.x = this.point.lng;
      pt.y = this.point.lat;
    }
    //gmaps doesn't have precision > 6 digits, get rid of 0's
    if(_.isNumber(pt.x)) pt.x = Math.round(pt.x*1000000)/1000000;
    if(_.isNumber(pt.y)) pt.y = Math.round(pt.y*1000000)/1000000;
    if(_.isNumber(this.ele)) pt['e'] = this.ele;
    if(_.isNumber(this.cad)) pt['c'] = this.cad;
    if(_.isNumber(this.hr)) pt['h'] = this.hr;
    if(_.isNumber(this.watts)) pt['p'] = this.watts;
    if(_.isNumber(this.time)) pt['t'] = this.time;
    if(_.isNumber(this.speed)) pt['s'] = this.speed_orig / 3.6; // convert back to m/s
    if(_.isNumber(this.temp)) pt['T'] = this.temp;
    if(_.isNumber(this.distance)) pt['d'] = Math.round(this.distance*1000)/1000;
    if(this.excludeFromMetrics) pt['k'] = true;
    pt['S'] = this.ghSurface;
    pt['R'] = this.roadClass;
    pt['m'] = this.modified;
    if (this.roadEnv !== undefined) {
      pt['RE'] = this.roadEnv;
      if (this.flattened) {
        pt['flat'] = this.flattened;
      }
    }

    return pt;
  },
  shallowClone: function() {
    return new rwgps.TrackPoint({
      point: this.point ? {lat: this.point.lat, lng: this.point.lng} : null,
      ele: this.ele,
      surface: this.surface,
      ghSurface: this.ghSurface,
      roadClass: this.roadClass
    });
  },
  distanceFromPoint: function(pt) {
    return this.distanceFromLatLng(pt.point);
  },
  distanceFromLatLng: function(latlng) {
    var lat1 = latlng.lat * Math.PI / 180;
    var lng1 = latlng.lng * Math.PI / 180;
    var lat2 = this.point.lat * Math.PI / 180;
    var lng2 = this.point.lng * Math.PI / 180;
    return rwgps.TrackPoint.haversine(lat1, lng1, lat2, lng2);
  },
  headingFromPoint: function(pt) {
    //http://mathforum.org/library/drmath/view/55417.html
    var lat1 = this.point.lat*Math.PI/180;
    var lon1 = this.point.lng*Math.PI/180;
    var lat2 = pt.point.lat*Math.PI/180;
    var lon2 = pt.point.lng*Math.PI/180;
    var rads = Math.atan2(
      Math.sin(lon2-lon1) * Math.cos(lat2),
      Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2-lon1)
    )
    var degs = rads*(180/Math.PI)
    return (degs + 360) % 360
  }
}
rwgps.TrackPoint.haversine = function(lat1, lng1, lat2, lng2) {
    var lat_diff = lat1 - lat2;
    var lng_diff = lng1 - lng2;
    var radius = 6378100;
    var lat_tmp = Math.sin(lat_diff / 2);
    var lng_tmp = Math.sin(lng_diff / 2);
    var a = lat_tmp*lat_tmp + Math.cos(lat1) * Math.cos(lat2) * lng_tmp*lng_tmp;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    // Quantize to 1mm: trig differs ~1 ULP across JS/WASM libm, which flips 100m filter decisions.
    return Math.round(radius * c * 1000) / 1000;
}
// options: {seconds: x}, or {meters: x}
rwgps.TrackPoint.calculateSplits = function(options) {
  var trackPoints = Routes.sampleGraph._data.points();
  if(trackPoints.length < 2) return;
  var attr = options.method;
  var offset = trackPoints[0][attr];
  var splitStartI = 0;
  var splits = [];
  var pct1 = 0;
  var pct2 = 0,
      pt, lastPt, lastI, metrics;
  for(var i=0,len=trackPoints.length; i < len; i++) {
    if(trackPoints[i][attr] - offset >= options.value) {
      pt = trackPoints[i];
      lastPt = trackPoints[i-1];
      pct2 = 1 - ((pt[attr] - offset) - options.value) / (pt[attr] - lastPt[attr]);
      if(pct2 == 1) {
        lastI = i;
        pct2 = 0;
      } else {
        lastI = i-1;
      }
      metrics = rwgps.TrackPoint.buildSplitObject(splitStartI, lastI, pct1, pct2);
      splits.push(metrics);
      splitStartI = lastI;
      pct1 = pct2;
      offset += options.value;
    } else if(i == len-1) {
      metrics = rwgps.TrackPoint.buildSplitObject(splitStartI, i, pct1);
      splits.push(metrics);
    }
  }
  return splits;
}

rwgps.TrackPoint.buildSplitObject = function(splitStartI, lastI, pct1, pct2) {
  var data = Routes.sampleGraph ? Routes.sampleGraph._data : Routes.data;
  var slice = data.slice(splitStartI, lastI-splitStartI+1, pct1, pct2);
  var metrics = slice.metrics();
  metrics.first_i = splitStartI;
  metrics.last_i = lastI;
  metrics.slice = slice;
  // add some fields so it matches up with what we get from the
  // server for lapSummaries
  metrics.moving_time = metrics.movingTime;
  metrics.elevation_gain = metrics.ele_gain;
  metrics.elevation_loss = metrics.ele_loss;
  metrics.pace = Math.round(metrics.moving_time / rwgps.LabelMaker.longLabel(metrics.distance, false, 5));
  return metrics;
}

rwgps.CoursePoint = function(opts) {
  this.notes = opts["notes"] || '';
  this.type = opts["type"] || "";
  //this.relativeDistance = opts["relativeDistance"] || 0;
  this.trackPointIndex = opts["trackPointIndex"] || -1;
  this.trackPoint = opts["trackPoint"] || null;
  this.marker = opts["marker"] || null;
  this.description = opts["description"] || '';
  this.photoIds = opts["photoIds"] || [];
  this.edited = opts["edited"];
  this.confirmed = opts["confirmed"] || false;

  this.init(opts);
}
rwgps.CoursePoint.prototype = new rwgps.TrackPoint();
rwgps.CoursePoint.prototype.toMiniObj = function() {
  var pt = {x: this.point.lng, y: this.point.lat};
  if(this.edited) pt['_e'] = 1;
  if(this.type) pt['t'] = this.type;
  if(this.notes) pt['n'] = this.notes;
  if(_.isNumber(this.distance)) pt['d'] = this.distance;
  if(_.isNumber(this.trackPointIndex)) pt['i'] = this.trackPointIndex;
  if(this.description) pt['description'] = this.description;
  if(this.photoIds && this.photoIds.length > 0) pt['photo_ids'] = this.photoIds;
  if(this.confirmed === true) pt['c'] = this.confirmed;

  return pt;
};
rwgps.CoursePoint.prototype.buildCoursePointTypeSelect = function() {
  var types = T.t('cuesheet_types');
  var self = this;
  var str = "<select class='coursePointType form-control' style='width:75%;display:inline;'>"
  _.each(types, function(val, key) {
    str += "<option value='" + key + "'" + (key == self.type ? " selected" : "") + ">" + val + "</option>";
  });
  return str += "</select>";
}
rwgps.CoursePoint.prototype.editHtml = function() {
  return "<div id='coursePointInfoWindowContent'>" +
           `<label class='inline'>${T.t('type')}</label>` +
           this.buildCoursePointTypeSelect() +
           `<label>${T.t('notes')}</label>` +
           "<textarea class='coursePointDescription'>" +
              _.escape(this.notes || "") +
           "</textarea>" +
           `<label>${T.t('description')}</label>` +
           "<textarea class='coursePointLongDescription'>" +
              _.escape(this.description || "") +
           "</textarea>" +
           "<div class='photos_view'></div>" +
           `<button type='submit' class='saveButton btn btn-primary'>${T.t('save')}</button>` +
           "<div class='bottom-buttons'>" +
            `<button type='submit' class='deleteButton btn btn-link'>${T.t('delete')}</button>` +
            `<button type='submit' class='cancelButton btn btn-link'>${T.t('cancel')}</button>` +
           "</div>" +
         "</div>";
}
rwgps.CoursePoint.prototype.previewHtml = function() {
  var desc = "<div id='poiInfoWindowContent' class='show'>" +
    "<p><span style='font-weight:bold;'>" + T.t('type') + ": </span> " + this.type + "</p>" +
    "<p><span style='font-weight:bold;'>" + T.t('notes') + ": </span> " + _.escape(this.notes) + "</p>";
  if(this.photoIds.length > 0) {
    //desc += "<p><span style='font-weight:bold;'>" + this.photoIds.length + " photos</span></p>";
    desc += "<p>" + T.t('show_photos', {count: (this.photoIds ? this.photoIds.length : 0)}) + "</span></p>";
  }
  desc += "</div>";
  return desc;
}
rwgps.CoursePoint.prototype.showHtml = function() {
  var desc = "<div id='poiInfoWindowContent' class='show'>" +
    "<p><span style='font-weight:bold;'>" + T.t('type') + ": </span> " + this.type + "</p>" +
    "<p><span style='font-weight:bold;'>" + T.t('notes') + ": </span> " + _.escape(this.notes) +"</p>";
  if(this.description && this.description.length > 0) {
    desc += "<p><span style='font-weight:bold;margin-right:5px;'>" + T.t('description') + ":</span>" +
      (this.description ? _.escape(this.description).replace(/\n|\r/gi,'<br>') : '');
  }

  if(this.photoIds.length > 0) {
     desc += "</p><br/><br/>" +
     _.map(this.photoIds, function(photoId) {
       return "<div style='float:left;border:1px solid #CCC;padding:2px;width:64;height:64px;'>" +
       "<a class='thickbox' href='/photos/medium/"+photoId+".jpg'>" +
         "<img src='/photos/milli/"+photoId+".jpg'></a></div>";
    }).join('');
  }
  desc += "</div>";
  return desc;
}
rwgps.PointOfInterest = function(opts) {
  this.id = opts["id"] || null;
  this.name = opts["name"] || '';
  this.url = opts["url"] || null;
  this.poiType = opts["poiType"];
  this.description = opts["description"] || '';
  this.photoIds = opts["photoIds"] || [];
  this.marker = null;
  this.readOnly = opts.hasOwnProperty("readOnly") ? opts["readOnly"] : false;
  this.route = null;
  this.visibility = opts['visibility'];
  this.userId = opts['userId'];
  this.library = opts.library;
  this.addToPoiLibrary = opts.library;
  this.saveOrUpdate = opts.library ? 'update' : undefined;

  this.init(opts);
}
rwgps.PointOfInterest.fromJSON = function(raw, ro) {
  if(raw === undefined) return;
  if(ro === undefined) ro = true;
  var pois = (typeof raw == "string" ? $.evalJSON(raw) : raw);
  var pts = [];
  if(pois) {
    for(var i = 0; i < pois.length; i++) {
      var pt = pois[i];
      // ro can be an array of ids that should be readonly, or it can be
      // a boolean that applies to all pois we're populating
      var poi = new rwgps.PointOfInterest({
        id: pt["id"],
        point: {lat: pt["lat"] || pt.y, lng: pt["lng"] || pt.x},
        name: pt["name"] || pt.name,
        poiType: pt["poi_type"] || pt.poi_type,
        description: pt["description"] || pt.description,
        url: pt["url"],
        readOnly: ro,
        library: pt.parent_type === 'Club',
        photoIds: pt["photo_ids"] || pt.photo_ids || [],
        visibility: pt['visibility'],
        userId: pt['user_id'],
        addToPoiLibrary: pt.parent_type === 'Club'
      });
      pts.push(poi);
    }
  }
  return pts;
}
rwgps.PointOfInterest.prototype = new rwgps.TrackPoint();
rwgps.PointOfInterest.prototype.copy = function() {
  const newPoi = this.toSaveObj()
  delete newPoi.id
  return rwgps.PointOfInterest.fromJSON([newPoi], false)[0]

}
rwgps.PointOfInterest.prototype.isEditable = function() {
  if(this.id == null) return true; //new POI

  var ns = rwgps.ns('config');
  if(ns.currentUser && ns.currentUser.id == this.userId)
    return true;
  else
    return false;
}

rwgps.PointOfInterest.prototype.addToRoute = function() {
  var map = this.marker.map
  this.ghosted = false;

  // make sure its in the pointsofinterest array

  if(!_.detect(map.pointsOfInterest, function(x) { return x.id == this.id; }, this))  {
    map.pointsOfInterest.push(this);
  }

  // unghost the icon
  this.marker.gmarker.setMap(null);
  this.marker = new rwgps.PoiIcon(this, map);
  map.closeStickyInfoWindow();

  // tell everyone its added
  rwgps.Events.trigger('pois:added', this);
}
rwgps.PointOfInterest.prototype.removeFromRoute = function() {
  var map = this.marker.map
  this.ghosted = true;

  //make sure its no longer in the pointsofinterest array
  map.pointsOfInterest = _.without(map.pointsOfInterest, this);

  //ghost the icon
  this.marker.gmarker.setMap(null);
  this.marker = new rwgps.PoiIcon(this, map);
  map.closeStickyInfoWindow();

  // tell everyone its removed
  rwgps.Events.trigger('pois:removed', [this]);
}

rwgps.PointOfInterest.prototype.toSaveObj = function() {
  var pt = { lat: this.point.lat, lng: this.point.lng, poi_type: this.poiType || 17};
  pt['id'] = this.id;
  pt['name'] = this.name;
  pt['description'] = this.description;
  if(this.photoIds && this.photoIds.length > 0) pt['photo_ids'] = this.photoIds;
  pt['url'] = this.url;
  pt['user_id'] = this.userId;
  pt['addToPoiLibrary'] = this.addToPoiLibrary;
  if (this.addToPoiLibrary) {
    pt['saveOrUpdate'] = this.saveOrUpdate
  }
  return pt;
}
// change this to be poi categories or something
// it is expected that rwgps.PointOfInterest.poiTypes and rwgps.PointOfInterest.poiTypesById are populated already (done in the view by the app)
rwgps.PointOfInterest.prototype.buildTypeSelect = function() {
  var types = rwgps.PointOfInterest.poiTypes;
  var str = "<select class='poiType' style='width: 100%'>";
  var selectedType = this.poiType ? this.poiType : 17;
  for(var i=0; i < types.length; i++) {
    if(!types[i].disabled || types[i]._id == selectedType) {
      str += "<option title='/images/" + rwgps.poiIconsPath() + types[i].icon + "?2' value='" + types[i]._id + "'" + (types[i]._id == selectedType ? " selected" : "") + ">" + types[i].name + "</option>";
    }
  }
  return str += "</select>";
}

const hasPoiLibrary = () => rwgps.activeNs.hasPoiLibrary

rwgps.PointOfInterest.prototype.editHtml = function() {
  var html = "<div id='poiInfoWindowContent'>"
  if (this.library || hasPoiLibrary()) {
    var checked
    if (this.addToPoiLibrary === undefined) {
      checked = this.library || !this.id // first load
    } else {
      checked = this.addToPoiLibrary !== false // subsequent loads
    }
    html += `
      <input type='checkbox' ${checked && 'checked'} class='addToPoiLibrary' data-poi_id='${(this.id || '')}' />
      <label class='inline'>${T.t('add_to_library')}</label>
      `
    if (this.library && this.addToPoiLibrary !== false) {
      html += `<span id='saveOrUpdate'>
        <div style='padding-left:15px'>
          <input name='saveOrUpdate' type='radio' value='update' ${this.saveOrUpdate !== 'save' && 'checked'} {/>
          <label class='inline'>${T.t('update_in_library')}</label>
        </div>
        <div style='padding-left:15px'>
          <input name='saveOrUpdate' type='radio' value='save' ${this.saveOrUpdate === 'save' && 'checked'}/>
          <label class='inline'>${T.t('save_as_new_poi')}</label>
        </div>
      </span>`
    }
  }
  html += `<div style='margin-bottom:5px;height:60px'>
            ${this.buildTypeSelect()}
          </div>
          <label>${T.t('name')}</label>
          <input type='text' class='poiName' value='${_.escape(this.name || "")}' />
          <label>${T.t('url')}</label>
          <input type='text' class='poiUrl' value='${_.escape(this.url || "")}' />
          <label>${T.t('description')}</label>
          <textarea class='poiDescription'>${_.escape(this.description || "")}</textarea>
          <div class='photos_view'></div>
          <button type='submit' class='saveButton btn btn-primary' data-poi_id='${(this.id || '')}'>${T.t('save')}</button>
          <div class='bottom-buttons'>
            <button type='submit' class='deleteButton btn btn-link' style='padding-bottom:0px' data-poi_id='${(this.id || '')}'>${T.t('delete')}</button>
            <button type='submit' class='cancelButton btn btn-link' style='padding-bottom:0px' data-poi_id='${(this.id || '')}'>${T.t('cancel')}</button>
            <button type='submit' class='poi_route_to btn btn-link' style='padding-bottom:0px' data-poi_id='${(this.id || '')}'>${T.t('route_to_poi')}</button>
          </div>
        </div>`
  return html;
}
rwgps.PointOfInterest.prototype.previewHtml = function() {
  var poiType = rwgps.PointOfInterest.poiTypesById[this.poiType];
  var desc = "<div id='poiInfoWindowContent' class='show'>" +
    (poiType && poiType.name != 'Generic' ? "<p><span style='font-weight:bold;'>" + T.t('type') + ": </span> " + poiType.name + "</p>" : "") +
    "<p><span style='font-weight:bold;'>" + T.t('name') + ": </span> " + _.escape(this.name) + "</p>";
  if(this.url)
    desc += "<p><span style='font-weight:bold;'>" + T.t('url') + ": </span> " + rwgps.Utils.truncate(this.url, 25) + "</p>";
  if(this.photoIds.length > 0) {
    //desc += "<p><span style='font-weight:bold;'>" + this.photoIds.length + " photos</span></p>";
    desc += "<p>" + T.t('show_photos', {count: (this.photoIds ? this.photoIds.length : 0)}) + "</span></p>";
  } else {
    desc += "<p style='font-style: italic'>" + T.t("click_for_details") + "</p>";
  }
  desc += "</div>";
  return desc;
}
rwgps.PointOfInterest.prototype.showHtml = function() {
  var map;
  var poiType = rwgps.PointOfInterest.poiTypesById[this.poiType];
  var desc = "<div id='poiInfoWindowContent' class='show'>" +
    (poiType && poiType.name != 'Generic'? "<p><span style='font-weight:bold;'>" + T.t('type') + ": </span> " + poiType.name + "</p>" : "") +
    "<p><span style='font-weight:bold;'>" + T.t('name') + ": </span> " + _.escape(this.name) + "</p>" +
    (this.url ? ("<p><span style='font-weight:bold;'>" + T.t('url') + ": </span> <a href='"+this.url+"' target='_blank'>" + rwgps.Utils.truncate(_.escape(this.url), 25) + "</a></p>") : '');
  if(this.description && this.description.length > 0) {
    desc += "<p><span style='font-weight:bold;margin-right:5px;'>" + T.t('description') + ":</span>" +
      _.escape(this.description).replace(/\r|\n/gi,'<br>')
  }
  map = this.marker.map;

  if(this.photoIds.length > 0) {
     desc += "</p><br/><br/>" +
     _.map(this.photoIds, function(photoId) {
       return "<div style='float:left;border:1px solid #CCC;padding:2px;width:64;height:64px;'>" +
       "<a class='thickbox' href='/photos/medium/"+photoId+".jpg'>" +
         "<img src='/photos/milli/"+photoId+".jpg'></a></div>";
    }).join('');
  }
  map = this.marker.map;
  if(map && map.inPlanningMode()) {
    // keep an easily accessible reference to this poi around so when these links are clicked we can get the poi
    map.poisById[this.id] = this;
    desc += '<div class="clear"></div><div class="spacer"></div><p>Editable in POI Library (<a href="javascript:;" class="poi_make_unique" data-poi_id="' + (this.id || '') + '">Make unique</a>)</p>';
    desc += '<div class="clear"></div><div class="spacer"></div><p><a href="javascript:;" class="poi_remove_from_route" data-poi_id="' + (this.id || '') + '">Remove from route</a></p>';
    desc += '<p><a href="javascript:;" class="poi_route_to" data-poi_id="' + (this.id || '') + '">'+T.t('route_to_poi')+'</a></p>';
  }
  desc += "</div>";
  return desc;
}



// WEBPACK FOOTER //
// ./public/javascripts/js_maps/points.js